import { cx } from '@linaria/core';

import { SizeButtonBase } from '../SizeButtonBase';
import type { SizeIconButtonBaseProps } from '../types';
import { styledButton } from './styles';

export const SizeIconButtonBase = ({
	size = 'S',
	bigIcon = false,
	className,
	...props
}: SizeIconButtonBaseProps) => {
	return (
		<SizeButtonBase
			size={size}
			className={cx(styledButton, className, 'icon', bigIcon && 'bigIcon')}
			{...props}
		/>
	);
};
